export default __webpack_public_path__ + "static/media/36I-102616_-15506_0.aea5d528.jpg";